import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {
    CasinoGameType,
    CasinoStudio,
    GameTag,
    ListCasinoGameRequest,
    ListCasinoGameResponse
} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {CasinoGameService} from "../../services/CasinoGameService";
import { ColumnType } from "../list/list/ColumnType";
import { SelectInput } from "../form/SelectInput";
import { CasinoGameTagService } from "../../services/CasinoGameTagService";
import { CasinoStudioService } from "../../services/CasinoStudioService";


interface State extends ListViewState<ListCasinoGameRequest> {
    form? : ListCasinoGameRequest;
    validationMap? : any;
    casinoStudios?: CasinoStudio[];
    casinoTags?: GameTag[];
    lookupExpanded?: boolean;
}
interface Props extends ListViewProps  {

}

export class CasinoGameListView extends ListView<State, ListCasinoGameRequest> implements FormListener<ListCasinoGameRequest>{

    columns = [
        { property : "id", name : "ID", orderBy : "id"},
        { property : "name", name : "Name", orderBy : "name"},
        { property : "gameType", name : "Type"},
        { property : "studio.name", name : "Studio"},
        { property : "gameTags", name : "Tags", renderer : (p : any,n : any,i : any) => 
            i.gameTags.map((item:any) => { return item.name }).join(',')
        },
        { property : "releaseDate", name : "Release Date", type : ColumnType.DATE},
        { property : "enabled", name : "Enabled", renderer : (p : string,n : string,i : any) => i[p] === true ? "Yes" : "No"},
        { property : "removed", name : "Removed", renderer : (p : string,n : string,i : any) => i[p] === true ? "Yes" : "No"},
        { property : "gameOrder ", name : "Game Order ", orderBy : "gameOrder", renderer : (p : any,n : any,i : any) => 
            <span>{i["gameOrder"]}</span>
        }
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/casino-game/" + item.id }

    ];

    service : CasinoGameService;
    casinoTagService: CasinoGameTagService;
    casinoStudioService: CasinoStudioService;

    constructor(props : Props){
        super(props, "/casino-games");
        this.state = {...this.state,  listRequest : {...this.state.listRequest, orderBy : "id"}, validationMap : {}, form : {}};
        this.service = getContainer().getCasinoGameService();
        this.casinoTagService = getContainer().getCasinoGameTagService();
        this.casinoStudioService = getContainer().getCasinoStudioService();
    }

    loadContent(): Promise<any>  {
        return Promise.all([
            this.casinoTagService.list({ offset : 0, limit: 100, orderBy : "name"}),
            this.casinoStudioService.list({ offset : 0, limit: 100, orderBy : "name"}),
        ]).then( (res : ListCasinoGameResponse[])=>{
            this.setState({ casinoTags : res[0].items, casinoStudios : res[1].items, form:{...this.state.form, casinoGameTypes:Object.values(CasinoGameType), casinoGameTags:res[0].items, casinoGameStudio:res[1].items}});
        })
    }
    
    onSubmit() : void | Promise<any> {
        if(this.state.form) {
            let listRequest:ListCasinoGameRequest = this.state.form;
            this.setState({listRequest:listRequest});
        }
    }
    onSubmitError() :  void {

    }

    formDidUpdate(formModel: ListCasinoGameRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : CasinoStudio, action : string) : Promise<any> | undefined {
        return;
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.setState({listRequest:listRequest});
        }
    }
    getTitle() {
        return "Casino Games";
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form}})
    }

    clearFilter() {
        this.setState({form: {}})
    }
    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <div className={"card-box"}>
                    <h4>Search Filters</h4>
                    <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                        <FormGroup className={"form-group"}>
                            <label>Name</label>
                            <FormInput model={"name"} className={"form-control"} validators={[Validators.strLength(1,255)]}/>
                            <span className={"help-text"}>Search by name</span>
                        </FormGroup>
                        <Submit className={"btn btn-primary"}>Search</Submit>
                    </Form>
                </div>
                <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : false})}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : true})}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                        <div className="row">
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Game Type</label>
                                    <SelectInput className="form-control  col-lg-4" model="casinoGameTypes" multiple={true}
                                        size={[...Object.keys(CasinoGameType)].length}
                                        values={[...Object.keys(CasinoGameType)]}
                                        required={true}
                                    >
                                    </SelectInput>
                                    <span className={"help-text"}>Search for user based on their Game Type. CTRL select for multiple types.</span>
                                </FormGroup>
                            </div>
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Studio</label>
                                    <SelectInput values={this.state.casinoStudios} required={true}
                                        size={this.state.casinoStudios!.length}
                                        convertOptionValueToModel={ (id) => {
                                        if(this.state.casinoStudios) {
                                        return this.state.casinoStudios.find(m => m.id+"" === id+"");
                                            } else {
                                                return "N/A";
                                            }
                                        }}
                                        multiple={true}
                                        convertModelValueToOption={(modelValue)=>modelValue.map((m:CasinoStudio)=>m.id)}
                                        optionModelValue={(m)=>m.id}
                                        displayValue={(mc : CasinoStudio) => String(mc.name)}  model="casinoGameStudio"  className="form-control" />
                                    <span className={"help-text"}>Search for user based on their Studio. CTRL select for studios.</span>
                                </FormGroup>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Game Tag</label>
                                    <SelectInput values={this.state.casinoTags} required={true}
                                    size={this.state.casinoTags!.length}
                                    modelValue={this.state.casinoTags}
                                        convertOptionValueToModel={ (id) => {
                                        if(this.state.casinoTags) {
                                        return this.state.casinoTags.find(m => m.id+"" === id+"");
                                            } else {
                                                return "N/A";
                                            }
                                        }}
                                        convertModelValueToOption={(modelValue)=>modelValue.map((m:GameTag)=>m.id)}
                                        optionModelValue={(m)=>m.id}
                                        multiple={true}
                                        displayValue={(mc : GameTag) => String(mc.name)}  model="casinoGameTags"  className="form-control" />
                                    <span className={"help-text"}>Search for user based on their Game Tags. CTRL select for tags.</span>
                                </FormGroup>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Removed</label><br/>
                                    <FormInput id={"removed"} model="removed" type="checkbox" onFocus={() => this.clearForAdvanced()}/><br/>
                                    <span className={"help-text"}>Search for user based on their removed. CTRL select for removed.</span>
                                </FormGroup>
                            </div>
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Enabled </label> <br/>
                                    <FormInput id={"enabled"} model="enabled" type="checkbox" onFocus={() => this.clearForAdvanced()}/><br/>
                                    <span className={"help-text"}>Search for user based on their enabled. CTRL select for enabled.</span>
                                </FormGroup>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Release Date Start</label>
                                    <FormInput model={"releaseDateStart"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                    <span className={"help-text"}>Search for user based on their release date start. CTRL select for release date start.</span>
                                </FormGroup>
                            </div>
                            <div className="col-lg-6">
                                <FormGroup className="form-group">
                                    <label>Release Date End</label>
                                    <FormInput model={"releaseDateEnd"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                    <span className={"help-text"}>Search for user based on their release date end. CTRL select for release date end.</span>
                                </FormGroup>
                            </div>
                        </div>
                        <div className="form-group">
                                <Submit className={"btn btn-primary"}>Search</Submit>
                                <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                        </div>
                    </Form>
                )}
                </div>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(CasinoGameListView);
